export const registerServiceWorker = () => {
    // eslint-disable-next-line no-restricted-syntax
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('./firebase-messaging-sw.js', { scope: './' });
    }
};
export default registerServiceWorker;
